(function() {
  'use strict';
  
  angular
    .module('app.plugins')
    .directive('marsPlugin', marsPlugin);
      
  marsPlugin.$inject = ['$log', '$compile'];
    
  function marsPlugin($log, $compile) {
    $log = $log.getInstance('marsPlugin');
    
    var directive = {
      link: link,
      restrict: 'E',
      scope: {
        'marsPluginName': '=',
        'marsPluginView': '@',
        'poll': '=',
        'result': '='
      },
      template: '<ng-include src="marsPluginTemplatePath"></ng-include><div class="ng-cloak ng-hide" ng-cloak ng-if="pluginViewMissing"><ng-transclude /></div>',
      transclude: true
    }
    return directive;
    
    function link(scope, element, attrs) {
      scope.pluginViewMissing = false;
      scope.$on('$includeContentError', function(event, args) {
        $log.warn('Plugin view "' + scope.marsPluginTemplatePath + '" is missing');
        scope.pluginViewMissing = true;
      });
      scope.$on('$includeContentLoaded', function(event, args) {
        scope.pluginViewMissing = false;
      })
      attrs.$observe('marsPluginView', function(view) {
        scope.$watch('marsPluginName', function(pluginName) {
          if (!view || !pluginName) {
            scope.pluginViewMissing = true;
            return;
          }
          scope.marsPluginTemplatePath = 
            'plugins/' + pluginName + '/' + pluginName + '.' + view + '.html';
        });
      });
    }
    
  }
  
})();